import { render, staticRenderFns } from "./PageExtendBehaviorEditor.vue?vue&type=template&id=af45b21a&scoped=true&"
import script from "./PageExtendBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./PageExtendBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PageExtendBehaviorEditor.vue?vue&type=style&index=0&id=af45b21a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af45b21a",
  null
  
)

export default component.exports